import { BodyRegular, Card } from 'components/Elements';
import ExpandableContentComponent from 'components/ExpandableContentComponent';
import React from 'react';
import strings from '../../../strings/strings.json';
import { BillCardProps, MainRow, Cell, CardBody, CourseList } from './BillingList';


export function BillCard({ monthlyBill }: BillCardProps): JSX.Element {
    const totalCoursesFee = monthlyBill.courseBills.reduce((sum, bill) => sum + bill.courseFee, 0);
    const enrolledLearnersFee = monthlyBill.enrollmentBills.reduce((sum, bill) => sum + bill.enrollmentsFee, 0);
    const numberOfEnrolledLearners = monthlyBill.enrollmentBills.reduce(
        (sum, bill) => sum + bill.numberOfEnrollments,
        0
    );

    const monthTotal = totalCoursesFee + enrolledLearnersFee + monthlyBill.subscriptionFee;

    const header = (
        <MainRow>
            <Cell>
                <BodyRegular $bold>{strings.billing.mainRow.month}</BodyRegular>
                <BodyRegular>{`${new Date(monthlyBill.month).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}`}</BodyRegular>
            </Cell>
            <Cell>
                <BodyRegular $bold>{strings.billing.mainRow.subscription}</BodyRegular>
                <BodyRegular>{`£${monthlyBill.subscriptionFee}`}</BodyRegular>
            </Cell>
            <Cell>
                <BodyRegular $bold>{strings.billing.mainRow.liveCourses}</BodyRegular>
                <BodyRegular>{`£${totalCoursesFee + enrolledLearnersFee} (${monthlyBill.courseBills.length})`}</BodyRegular>
            </Cell>
            <Cell>
                <BodyRegular $bold>{strings.billing.mainRow.enrollments}</BodyRegular>
                <BodyRegular>{`£${enrolledLearnersFee} (${numberOfEnrolledLearners})`}</BodyRegular>
            </Cell>
            <Cell>
                <BodyRegular $bold>{strings.billing.mainRow.total}</BodyRegular>
                <BodyRegular>{`£${monthTotal}`}</BodyRegular>
            </Cell>
        </MainRow>
    );

    return (
        <Card>
            <CardBody>
                <ExpandableContentComponent
                    headline={header}
                    content={<CourseList
                        courseBills={monthlyBill.courseBills}
                        enrollmentBills={monthlyBill.enrollmentBills} />}
                    closedHeightInPx={0} />
            </CardBody>
        </Card>
    );
}
